import { render, staticRenderFns } from "./comp_Footer-Newsletter.vue?vue&type=template&id=1461ea0a&scoped=true&"
import script from "./comp_Footer-Newsletter.vue?vue&type=script&lang=js&"
export * from "./comp_Footer-Newsletter.vue?vue&type=script&lang=js&"
import style0 from "./comp_Footer-Newsletter.vue?vue&type=style&index=0&id=1461ea0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1461ea0a",
  null
  
)

export default component.exports